import { render, staticRenderFns } from "./IndexNew.vue?vue&type=template&id=1216d02c&scoped=true"
import script from "./IndexNew.vue?vue&type=script&lang=js"
export * from "./IndexNew.vue?vue&type=script&lang=js"
import style0 from "./IndexNew.vue?vue&type=style&index=0&id=1216d02c&prod&lang=scss&scoped=true"
import style1 from "./IndexNew.vue?vue&type=style&index=1&id=1216d02c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1216d02c",
  null
  
)

export default component.exports